import type { JSONContent } from '@tiptap/core';

export function getNodeText(node?: JSONContent | JSONContent[] | null): string {
  if (!node) {
    return '';
  }

  if (Array.isArray(node)) {
    return node.map(getNodeText).filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
  }

  const parts: string[] = [];

  if (typeof node.text === 'string') {
    parts.push(node.text);
  }

  if (Array.isArray(node.content)) {
    parts.push(getNodeText(node.content));
  }

  return parts.join(' ').replace(/\s+/g, ' ').trim();
}
